import { Component, OnInit, OnChanges, OnDestroy, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { Form, FormGroup, FormsModule } from '@angular/forms';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// service
import { LoginService } from '../../../../shared/services/login.service';
import { PriceService } from '../../../services/price.service';
// models
import { AppState } from '../../../models/app-state.interface';
import { BookerItem } from '../../../models/booking.interface';
import { BookingInitState } from '../../../models/booking-reducer.interface';
import { UserInitState } from '../../../../shared/models/user-reducer.interface';
// globals
import { COUNTRY_CODES } from '../../../../shared/globals';
import { CommonModule } from '@angular/common';
import { UPDATE_MARKETING_ENROLMENT, UPDATE_USER_STATUS } from '@shared/reducers/user.reducer';
import { SharedDirectiveModule } from '@shared/shared-directive.module';

declare var ga: any;

@Component({
  selector: 'app-booker-form',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedDirectiveModule],
  templateUrl: './booker-form.component.html',
  styleUrls: ['./booker-form.component.scss']
})
export class BookerFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() currentBooking;
  @Input() bookingState: BookingInitState;
  @Input() user: UserInitState;
  @Input() appCopy;
  @Input() selectedLanguage;
  @Input() formData;

  @Output()
  validatePhoneNumberParent: EventEmitter<any> = new EventEmitter();

  @Output()
  emailInputChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('form') form;

  @ViewChild('termsFormExpresscheckout') termsFormExpresscheckout;

  private _verifyEmailSubscription: Subscription;
  private _tokenSubscription: Subscription;

  private _hasReturnSession: Boolean = false;

  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all]
  }
  public showLogin = false;
  public showSetPassword = false;
  public showLoginLoader = false;
  public bookerData: BookerItem = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    countryCode: '44'
  };
  public userLoggedIn = false;
  public userName = '';
  public bookingType;
  public userHasFirstLastName = true;
  public showOptOutMarketingEnrolment = true;
  public bookingAmendSection;
  public emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // public userLoaded = false;
  public newUserSetPassword = '';

  constructor(
    private _appStore: Store<AppState>,
    private _pricingService: PriceService,
    private _loginService: LoginService,
  ) { }

  ngOnInit() {
    const getFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails;
    const departureFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    const arrivalFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[getFlight.length - 1];
    const departureCountryCode = departureFlight.departureAirport.airportCountryCode;
    const arrivalCountryCode = arrivalFlight.arrivalAirport.airportCountryCode;

    let departureCountryInfo: any;
    let arrivalCountryInfo: any;
    for (let i = 0; i < this.countryCodes.all.length; i++) {
      const country = this.countryCodes.all[i];
      if (departureCountryCode === country.countryCodeName) {
        departureCountryInfo = country;
      }
      if (arrivalCountryCode === country.countryCodeName) {
        arrivalCountryInfo = country;
      }
    }

    this.bookerData.countryCode = departureCountryInfo ? departureCountryInfo.countryCode : arrivalCountryInfo ? arrivalCountryInfo.countryCode : this.bookerData.countryCode;
    this.countryCodes.featured = [];
    if (departureCountryInfo && arrivalCountryInfo) {
      if (departureCountryInfo.countryCode === arrivalCountryInfo.countryCode) {
        this.countryCodes.featured.push(departureCountryInfo)
      }
      else {
        if (arrivalCountryInfo) this.countryCodes.featured.push(arrivalCountryInfo);
        if (departureCountryInfo) this.countryCodes.featured.push(departureCountryInfo);
      }
    }
    this.bookingAmendSection = this.bookingState.bookingDetails.bookingAmendSection;
    this._hasReturnSession = this.getState(this._appStore).flightFinderReducer.returnSessionString !== null;

    // if user logged in as Guest (no password), show set password
    if (this.user.userDetails.userLoggedIn && this.user.userDetails.userRole === 'GUEST') {
      this.showSetPassword = true;
    }

    this._verifyEmailSubscription = this._loginService.validateUserSubject$
      .subscribe(res => {

        this.showLogin = false;
        this.showSetPassword = false;
        this.userLoggedIn = false;
        this.showOptOutMarketingEnrolment = !res.hasMarketingEnrolment;
        this.userName = '';

        this._appStore.dispatch(UPDATE_MARKETING_ENROLMENT({ hasMarketingEnrolment: res.hasMarketingEnrolment }));
        this._appStore.dispatch(UPDATE_USER_STATUS({ userStatus: res.verifyCustomerStatus }));

        // if email matches an account with password, show login panel
        if (res.userLoginStatus === 1) {
          this.showLogin = true;
          this.userName = res.firstName;
        }

        // if email doesn't match any account, show set password
        if (res.userLoginStatus === 3) {
          this.showSetPassword = true;
        }

      });

    this._tokenSubscription = this._loginService.tokenSubject$
      .subscribe(token => {
        this.showLoginLoader = false;

        if (token.error) {
          // this.handleErrors();
        }
      },
        err => console.log(err));

    this.setUserValues();
  }

  skiplogin() {
    this.showLogin = false;
    ga('send', 'event', 'Vanilla', 'Pay - Info', 'SkipLogin');
  }
  // on user changes
  // set user values
  ngOnChanges(changes: any) {
    if (changes.user) {
      if (!changes.user.firstChange) {
        this.user = changes.user.currentValue;
        this.setUserValues();
      }
    }
    this.updateAllLabels(this.appCopy.panelHeader['bookerOtherCountry'+this.selectedLanguage]);
  }

  updateAllLabels(newLabel: string) {
    this.countryCodes.all = this.countryCodes.all.map((country) => ({
      ...country,
      label: newLabel
    }));
  }


  setUserValues() {
    this.userLoggedIn = this.user.userDetails.userLoggedIn;
    this.userHasFirstLastName =
      (this.user.userDetails.currentUser.firstName !== null && typeof this.user.userDetails.currentUser.firstName !== 'undefined')
      && (this.user.userDetails.currentUser.lastName !== null && typeof this.user.userDetails.currentUser.lastName !== 'undefined');

    this.bookingType = this.bookingState.bookingDetails.bookingType;

    if (this.user.userDetails.userLoggedIn) {
      this.showLogin = false;
      this.showLoginLoader = false;
      this.showSetPassword = false;

      this.showOptOutMarketingEnrolment = !this.user.userDetails.hasMarketingEnrolment;
    }

    if ((this._hasReturnSession && this.currentBooking.bookingUser !== null) || this.bookingType === 'amend') {
      this.bookerData.emailAddress = this.currentBooking.bookingUser.emailAddress;
      this.bookerData.firstName = this.currentBooking.bookingUser.firstName.replace(/^\s+/g, '');
      this.bookerData.lastName = this.currentBooking.bookingUser.lastName.replace(/^\s+/g, '');
      this.bookerData.countryCode = this.currentBooking.bookingUser.countryCode;
      this.bookerData.phoneNumber = this.currentBooking.bookingUser.phoneNumber;
    } else if (this.userLoggedIn) {
      this.bookerData.emailAddress = this.user.userDetails.userEmail;
      this.bookerData.firstName = this.user.userDetails.currentUser.firstName.replace(/^\s+/g, '');
      this.bookerData.lastName = this.user.userDetails.currentUser.lastName.replace(/^\s+/g, '');
      if (this.user.userDetails.currentUser.mobileNumberCountryCode !== '' &&
        this.user.userDetails.currentUser.mobileNumber !== '') {
        this.bookerData.countryCode = this.user.userDetails.currentUser.mobileNumberCountryCode;
        this.bookerData.phoneNumber = this.user.userDetails.currentUser.mobileNumber;
      }
    }

    if (this.formData.set && this.formData.data && !this.userLoggedIn && !(this._hasReturnSession && this.currentBooking.bookingUser !== null)) {
      this.bookerData.emailAddress = this.formData.data.bookerForm.bookerEmail;
      this.bookerData.firstName = this.formData.data.bookerForm.bookerFirstName?.replace(/^\s+/g, '');
      this.bookerData.lastName = this.formData.data.bookerForm.bookerLastName?.replace(/^\s+/g, '');
      this.bookerData.countryCode = this.formData.data.bookerForm.contactCountryCode;
      this.bookerData.phoneNumber = this.formData.data.bookerForm.contactPhone;
      this.newUserSetPassword = this.formData.data.bookerForm.setPassword;
    }

    // this.userLoaded = true;
  }

  resetValidationExpressCheckout() {
    this.emailInputChange.emit();
    // console.log(this.termsFormExpresscheckout);
  }

  verifiyAccount(email) {

    if (!this.userLoggedIn) {
      if (this.emailPattern.test(email)) {
        this._pricingService.getPrice();
        // this._loginService.updateUserEmail(email);
        this._loginService.validateEmail(email);
      } else {
        this.showLogin = false;
        this.userName = '';
        this.form.controls['bookerEmail'].setErrors({ 'pattern': true });
      }
    }
  }

  validatePassword(password) {

    if (password !== '' && password.length < 6) {
      this.form.controls['setPassword'].setErrors({ 'pattern': true });
    }
  }

  validatePhoneNumber(countryCode, phoneNumber) {
    if (phoneNumber !== '') {
      const value = '+' + countryCode + phoneNumber;
      // console.log(value)
      this.validatePhoneNumberParent.emit(value);
    }
  }

  inlineLogin(email, password) {
    this.showLoginLoader = true;
    const encodedPassword = encodeURIComponent(password);
    const params = 'grant_type=password&username=' + encodeURIComponent(email) + '&password=' + encodedPassword;
    const storeCookie = true;
    const isGuest = false;

    this.showLoginLoader = true;
    this._loginService.getToken(params, storeCookie, isGuest, email);
    this._loginService.userHasPassword();
  }

  logout() {
    this._loginService.logout();
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._tokenSubscription.unsubscribe();
  }

}
